import request from '../../src/state/modules/axios'

export function getSchools(params){
    return request({
        url: '/api/erp-schools',
        method: 'get',
        params: params
    })
}

export function addSchool(data){
    return request({
        url:'/api/schools',
        method:'post',
        data
    })
}

export function editSchool(data){
    return request({
        url: `/api/schools/${data.id}`,
        method:'put',
        data
    })
}

export function deleteSchool(data){
    return request({
        url: `/api/schools/${data.id}`,
        method: 'delete'
    })
}

export function getUserByPinfl(params) {
    return request({
        url: '/api/get-data-with-pinfl',
        method: 'get',
        params,
    })
}
